<div
    searchuser
    (select)="_onSelect($event)"
></div>
